// src/hooks/useEleve.js
import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useCombinedResults = (queryparams, enabled) => {

  const urldelete = queryparams && `${url}combined-classes-results/${queryparams}`;
  return useApi(urldelete, [],null, enabled);
};